import { useCallback, useEffect, useState } from 'react';

import {
  LifecycleEvent,
  Pagination,
  lifecycleAPI,
  lifecycleErrorMessage,
} from '@/services/lifecycleAPI';

export const EVENTS_PER_PAGE = 25;

const useEvents = (eventKey: string | null, page: number) => {
  const [events, setEvents] = useState<LifecycleEvent[]>([]);
  const [pagination, setPagination] = useState<Pagination | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);
    lifecycleAPI
      .listEvents({
        ...(eventKey ? { event_key: eventKey } : {}),
        page,
        per_page: EVENTS_PER_PAGE,
      })
      .then((result) => {
        if (!active) return;
        setEvents(result.data);
        setPagination(result.pagination);
      })
      .catch((err) => {
        if (active) {
          setError(
            lifecycleErrorMessage(err, 'Could not load the system events.'),
          );
        }
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [eventKey, page, attempt]);

  const retry = useCallback(() => setAttempt((n) => n + 1), []);

  return { events, pagination, loading, error, retry };
};

export default useEvents;
